// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160847/js/" + chunkId + "." + {"44":"97cebcee","225":"5d8f29aa","481":"4d5e81e1","486":"93dadf9a","770":"b8f7b914"}[chunkId] + ".0.6545226919480662.chunk.js";
};